/**
 * CD-ICONS-01 — the one place the icon flag's NAME is written.
 *
 * `icon_system_v1` is a CLIENT UI-rollout flag: it gates the DISPLAY LAYER
 * only — which glyph paints — and nothing else. It grants no data, gates no
 * endpoint, and changes no copy.
 *
 * ── THE SWAP PATTERN ───────────────────────────────────────────────────────
 * A migrated surface calls this ONCE and switches a WHOLE GLYPH SLOT on the
 * result, the way `HealthHomeSlot` switches a whole component rather than
 * sprinkling conditionals. That is what makes the OFF path the untouched
 * original element for element instead of a near-copy that can drift: there is
 * one branch per surface, and the false arm is the code that was already there.
 *
 * ── INDEPENDENCE FROM THE TEAM-PAGE FLAGS ──────────────────────────────────
 * The four Team-page flags (`coach_team_home_v1`, `coach_athlete_detail_v1`,
 * `athlete_team_tab_v1`, `athlete_kudos_v1`) own LAYOUT. This owns ART. A
 * Team-page surface that is ON still paints today's emoji unless this is on
 * too, and this being on never turns a layout on — so either side can be
 * rolled back alone. There is no ordering constraint in either direction.
 *
 * Fail-closed by construction: `useServerFlag` reads false for an unknown or
 * unreachable config, which is today's glyphs.
 */

import { useServerFlag } from './useServerFlag';

/** The flag id, seeded false by supabase-migration-icon-system-v1-flag.sql. */
export const ICON_SYSTEM_FLAG = 'icon_system_v1';

/** True when the ratified icon system paints. False = today's glyphs. */
export function useIconSystem(): boolean {
  return useServerFlag(ICON_SYSTEM_FLAG);
}
